var Side = /* @__PURE__ */ ((Side2) => {
  Side2[Side2["left"] = -1] = "left";
  Side2[Side2["right"] = 1] = "right";
  return Side2;
})(Side || {});
export {
  Side
};
//# sourceMappingURL=index242.js.map
